interface IGetJasperReportKeyArgs {
    entityName: string;
    docId?: string;
}

export const getJasperInfoKey = ({
    entityName,
    docId,
}: IGetJasperReportKeyArgs) => `${entityName}_${docId ?? 'n'}`;
